// extracted by mini-css-extract-plugin
export default {"discountBadge":"discountBadge__7zIRE","discountIcon":"discountIcon__7ugmZ","promoTextValue":"promoTextValue__R6BeK"};